<div id="slider1">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-3">
               CBSE Affiliation No.: 530218
            </div>
            
            <div class="col-6">
                <!-- <marquee behavior="scroll" direction="left"  routerLink="/admission/registration-form">Admission open for Toddlers' Club to VIII  & XI.</marquee> -->
            </div>
            <div class="col-3">
                <span class="float-right">School Code : 40203</span> 
            </div>
        </div>
        
    </div>
</div>